export const Vertical = 'vertical'
